module.exports = __webpack_public_path__ + "img/qz-windows-menu.2c6012aa.png";